module.exports = "/_next/static/images/99e25e03073c8679c6147a6a64b2daaa-lock.svg.webp";